import { createSlice } from '@reduxjs/toolkit'

interface ErrorState {
  data: ErrorData | undefined
}

const initialState: ErrorState = {
  data: undefined
}

export interface ErrorData {
  type: string
  error: {
    message: string
    response: {
      status: number
      data: {
        errors: object
      }
    }
  }
}

export const errorSlice = createSlice({
  name: 'errors',
  initialState,
  reducers: {
    setError(state, action) {
      state.data = action.payload
    },
    deleteError(state, _action) {
      state.data = undefined
    }
  }
})

export const { setError, deleteError } = errorSlice.actions

export default errorSlice.reducer
